// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type BoundMaterialLeadTimeConfigFields_MaterialLeadTimeConfigFragment = { __typename?: 'MaterialLeadTimeConfig', id: string, minLeadTimeInDays: number, maxLeadTimeInDays: number, expectedLeadTimeInDays: number, reasonNote?: string | null | undefined, variants: Array<{ __typename?: 'MaterialLeadTimeConfigVariant', id: string, minLeadTimeInDays?: number | null | undefined, maxLeadTimeInDays?: number | null | undefined, expectedLeadTimeInDays?: number | null | undefined, reasonNote?: string | null | undefined, market?: { __typename?: 'Market', id: string, name: string } | null | undefined }> };

export type BoundMaterialLeadTimeConfigFields_MaterialLeadTimeConfigVariantFragment = { __typename?: 'MaterialLeadTimeConfigVariant', id: string, minLeadTimeInDays?: number | null | undefined, maxLeadTimeInDays?: number | null | undefined, expectedLeadTimeInDays?: number | null | undefined, reasonNote?: string | null | undefined, market?: { __typename?: 'Market', id: string, name: string } | null | undefined };

export const BoundMaterialLeadTimeConfigFields_MaterialLeadTimeConfigVariantFragmentDoc = gql`
    fragment BoundMaterialLeadTimeConfigFields_MaterialLeadTimeConfigVariant on MaterialLeadTimeConfigVariant {
  id
  minLeadTimeInDays
  maxLeadTimeInDays
  expectedLeadTimeInDays
  reasonNote
  market {
    id
    name
  }
}
    `;
export const BoundMaterialLeadTimeConfigFields_MaterialLeadTimeConfigFragmentDoc = gql`
    fragment BoundMaterialLeadTimeConfigFields_MaterialLeadTimeConfig on MaterialLeadTimeConfig {
  id
  minLeadTimeInDays
  maxLeadTimeInDays
  expectedLeadTimeInDays
  reasonNote
  variants {
    ...BoundMaterialLeadTimeConfigFields_MaterialLeadTimeConfigVariant
  }
}
    ${BoundMaterialLeadTimeConfigFields_MaterialLeadTimeConfigVariantFragmentDoc}`;